module.exports = __webpack_public_path__ + "media/images/japan/tips_1-adf227b78d62033c6e95616d7ce2de94.jpg";